function Flight() {
    return (
      <div >
        Flights
      </div>    
    );
  }
  
  export default Flight;